module.exports = __webpack_public_path__ + "img/jewelleryMain@2x.402e805.webp";